export interface HomeHubImageAsset {
  readonly key: string;
  readonly path: string;
}

export const HOME_HUB_ASSETS = {
  cosmicBackground: { key: 'cosmic-home-bg', path: 'assets/home/cosmic-home-bg.png' },
  logo: { key: 'home-logo', path: 'assets/home/logo.png' },
  cosmo: { key: 'cosmo-idle', path: 'assets/shared/cosmo/cosmo-idle.png' },
  platform: { key: 'home-platform', path: 'assets/home/platform.png' },
  numberKingdom: { key: 'number-kingdom', path: 'assets/home/number-kingdom.png' },
  storyForest: { key: 'story-forest', path: 'assets/home/story-forest.png' },
  discoveryLab: { key: 'discovery-lab', path: 'assets/home/discovery-lab.png' },
  lockedWorld: { key: 'locked-world', path: 'assets/home/locked-world.png' },
  foregroundCrystals: { key: 'cosmic-crystals', path: 'assets/home/cosmic-crystals.png' },
  playButton: { key: 'home-play', path: 'assets/home/play.png' },
  continueButton: { key: 'home-continue', path: 'assets/home/continue-adv.png' },
  dailyMission: { key: 'nav-daily', path: 'assets/home/daily-mission.png' },
  mathWorld: { key: 'nav-math', path: 'assets/home/math-world.png' },
  readingWorld: { key: 'nav-reading', path: 'assets/home/reading-world.png' },
  rewards: { key: 'nav-rewards', path: 'assets/home/rewards.png' },
  parentArea: { key: 'nav-parent', path: 'assets/home/parent.png' },
  settings: { key: 'nav-settings', path: 'assets/home/settings.png' },
  starLearnerHud: { key: 'hud-star-learner', path: 'assets/shared/ui/star-learner.png' },
  diamondHud: { key: 'hud-diamonds', path: 'assets/shared/ui/blue-dia.png' },
  starHud: { key: 'hud-stars', path: 'assets/shared/ui/star-bar.png' },
  worldEnergyHud: { key: 'hud-world-energy', path: 'assets/shared/ui/world-energy.png' },
} as const satisfies Record<string, HomeHubImageAsset>;

export const HOME_HUB_ASSET_LIST = Object.values(HOME_HUB_ASSETS);

export function preloadHomeHubAssets(scene: Phaser.Scene) {
  HOME_HUB_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingHomeHubAssets(textures: Phaser.Textures.TextureManager) {
  return HOME_HUB_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}
